import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext({ ids: [], has: () => false, toggle: () => {}, count: 0, refresh: () => {} });

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try {
      const { data } = await api.get("/wishlist/ids");
      setIds(data.ids || []);
    } catch { setIds([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = (id) => ids.includes(id);

  const toggle = async (id) => {
    if (!user) return false;
    const isIn = ids.includes(id);
    // optimistic
    setIds((prev) => isIn ? prev.filter((x) => x !== id) : [...prev, id]);
    try {
      if (isIn) await api.delete(`/wishlist/${id}`);
      else await api.post(`/wishlist/${id}`);
      return !isIn;
    } catch {
      // revert
      setIds((prev) => isIn ? [...prev, id] : prev.filter((x) => x !== id));
      return isIn;
    }
  };

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, count: ids.length, refresh }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
